module.exports = __webpack_public_path__ + "img/ava-bot256.ccf0574b.png";